<app-header
  title="{{ 'movacarfleet_combined_detail_title' | translate }}"
  [backTo]="combiNumber ? '/fleet/orders' : null"
>
  <ng-container actions>
    <ion-button
      *ngIf="!combiNumber"
      id="continue-order"
      color="secondary"
      fill="solid"
      routerLink="/fleet/orders"
      (click)="cancel()"
      [disabled]="!this.fileUploadService.allFilesUploaded()"
    >
      {{ 'cancel' | translate }}
    </ion-button>
    <ion-button
      *ngIf="!combiNumber"
      id="new-order"
      color="secondary"
      fill="solid"
      (click)="onSubmit()"
      [disabled]="orders().length === 1 || !this.fileUploadService.allFilesUploaded()"
    >
      {{ 'movacarfleet_combined_submit' | translate }}
    </ion-button>

    <ion-button
      *ngIf="combiNumber && !isCombiOrderCancelled()"
      id="cancel"
      color="danger"
      fill="solid"
      (click)="onCancelOrders(combiNumber)"
    >
      {{ 'movacarfleet_order_cancel_combined_order' | translate | titlecase }}
    </ion-button>
  </ng-container>
</app-header>

<ion-content [fullscreen]="true" color="light">
  <div class="ion-padding">
    <ion-card class="summary-card">
      <ion-card-content>
        <div class="header-container">
          <ion-text [color]="ordersCountColor()">
            {{ orders().length }} / {{ maxOrders }}
          </ion-text>
        </div>

        <div class="ion-margin-bottom">
          <ion-list>
            <app-skeleton-list
              *ngIf="orders().length === 0"
              [count]="2"
              class="skeleton"
            />
            <app-order-item
              *ngFor="let order of orders()"
              [orderItem]="order"
            />
          </ion-list>
        </div>

        <div class="ion-margin-bottom">
          <ion-list>
            <ion-item class="ion-no-padding">
              <ion-label slot="end"
                >{{ 'movacarfleet_order_co_total_amount' | translate
                }}</ion-label
              >
              <ion-label slot="end"
                >{{ totalAmount() | currency: 'EUR' }}</ion-label
              >
            </ion-item>
          </ion-list>
        </div>

        <div class="ion-margin-bottom add-order-container" *ngIf="!combiNumber">
          <ion-button
            color="secondary"
            [disabled]="orders().length >= maxOrders || !this.fileUploadService.allFilesUploaded()"
            routerLink="/fleet/orders/combined/new"
            [state]="{ initialValues: { offerType: offerType(), brand: brand() } }"
          >
            {{ 'movacarfleet_combined_add_order' | translate }}
          </ion-button>

          <ion-text
            color="danger"
            *ngIf="!this.fileUploadService.allFilesUploaded()"
          >
            {{ 'movacarfleet_orders_files_error_text_upload_all_files' |
            translate }}
          </ion-text>

          <ion-button
            class="upload-all-files-button"
            *ngIf="!this.fileUploadService.allFilesUploaded()"
            (click)="handleFilesReUpload()"
            >{{ 'movacarfleet_orders_files_upload_all_files' | translate
            }}</ion-button
          >
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
